import { defineNuxtPlugin } from '#imports';
import appStrings from './default.json';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.globalProperties.$appStrings = appStrings;
});
